import React from 'react';
import './AdministrativeStructure.css';

const AdministrativeStructure = () => {
  return (
    <div className="admin-structure">
      <div className="admin-wrapper">
        <h2 className="admin-title">🏢 Administrative Structure</h2>
        <p className="admin-intro">
          Igbo-Eze North Local Government Council operates a decentralized, people-centered administrative system designed to enhance service delivery, inclusive development, and effective governance.
        </p>

        <section className="admin-section">
          <h3>🧭 Governance Framework</h3>
          <ul>
            <li><strong>The Executive Arm</strong> – Led by the Executive Chairman, responsible for implementing policies and managing day-to-day operations.</li>
            <li><strong>The Legislative Arm</strong> – Consists of 20 elected Councilors, representing each ward, who make laws and provide oversight.</li>
            <li><strong>The Civil Service</strong> – Comprising 516 civil servants and departmental staff responsible for executing government functions.</li>
            <li><strong>Security Arm</strong> – Includes the Neighbourhood Watch, Forest Guards, and other operatives working alongside federal security agencies to ensure safety and peace.</li>
          </ul>
        </section>

        <section className="admin-section">
          <h3>🏛️ Development Centres</h3>
          <p>For administrative efficiency, the LGA is subdivided into four Development Centres:</p>
          <table className="admin-table">
            <thead>
              <tr>
                <th>Development Centre</th>
                <th>Headquarters</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Igbo-Eze North-West</td>
                <td>Ette</td>
              </tr>
              <tr>
                <td>Igbo-Eze North-East</td>
                <td>Uda</td>
              </tr>
              <tr>
                <td>Igbo-Eze North-Central</td>
                <td>Ogrute</td>
              </tr>
              <tr>
                <td>Igbo-Eze North-South</td>
                <td>Umuida</td>
              </tr>
            </tbody>
          </table>
          <p>These centres function alongside the central Local Government Headquarters at Ogrute.</p>
        </section>

        <section className="admin-section">
          <h3>🏬 Local Government Departments</h3>
          <p>There are eight departments, each playing a crucial role in governance and service delivery:</p>
          <ol>
            <li>Administration</li>
            <li>Finance and Accounts</li>
            <li>Works and Housing</li>
            <li>Planning, Research & Statistics (PRS)</li>
            <li>Healthcare</li>
            <li>Agriculture & Veterinary Services</li>
            <li>Water, Sanitation and Hygiene (WASH)</li>
            <li>Education and Community Development</li>
          </ol>
          <p>Each department is led by a Head of Department (HOD), who is a senior civil servant appointed by the Enugu State Local Government Service Commission.</p>
        </section>

        <section className="admin-section">
          <h3>👥 Local Government Workforce</h3>
          <p>The total workforce includes:</p>
          <ul>
            <li>516 Civil Servants</li>
            <li>20 Councilors</li>
            <li>Over 1,400 others (including political appointees, traditional authorities, ad hoc staff, security personnel, and community leaders)</li>
          </ul>
          <p>This structure ensures efficient policy implementation and grassroots engagement.</p>
        </section>

        <section className="admin-section">
          <h3>🔄 Succession & Capacity Building</h3>
          <p>With 75% of civil servants set to retire by 2027, the Council is taking proactive steps to recruit and retain young professionals, strengthen internal systems, and provide capacity-building opportunities for sustainable governance.</p>
        </section>
      </div>
    </div>
  );
};

export default AdministrativeStructure;